import React from 'react';
import { render } from 'react-dom';
import RecipeArchiveSearch from './apps/RecipeArchiveSearch/RecipeArchiveSearch';

const recipeArchiveSearch = document.getElementById('recipe-archive-search-app');

if (recipeArchiveSearch) {
  render(
    <RecipeArchiveSearch {...recipeArchiveSearch.dataset} />,
    recipeArchiveSearch
  );
}
